import { useState } from 'react';

const SvgIcon = ({color = '#a59e9e', hoverColor, size = '24'}) => {
  const defaultFillStyle = color;
  let [fillStyle, setFillStyle] = useState(defaultFillStyle);
  
  return (
    <div
      onMouseEnter={() => { setFillStyle(typeof hoverColor === 'string' ? hoverColor : defaultFillStyle); }}
      onMouseLeave={() => { setFillStyle(defaultFillStyle); }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill="none"
        version="1.1"
        viewBox="0 0 24 24"
      >
        <path
          id="path1960"
          fill={fillStyle}
          fillOpacity="0.98"
          strokeWidth="1"
          d="M2.4 24 0 21.6 9.6 12 0 2.4 2.4 0 12 9.6 21.6 0 24 2.4 14.4 12l9.6 9.6-2.4 2.4-9.6-9.6Z"
        ></path>
      </svg>
    </div>
  )
};

export default SvgIcon;
